import moment from 'moment';

export default {
  computed: {
    /**
     * The number of active directors, going by this.companyOverview
     *
     * @returns {number}
     */
    numberOfActiveDirectors() {
      let result = 0;

      if (this.companyOverview && this.companyOverview.officers) {
        for (let i = 0; i < this.companyOverview.officers.length; i += 1) {
          if (this.companyOverview.officers[i].current_status === 'open') {
            result += 1;
          }
        }
      }

      return result;
    },
    numberOfHseCases() {
      let result = 0;

      if (this.companyOverview && this.companyOverview.hsecases) {
        for (let i = 0; i < this.companyOverview.hsecases.length; i += 1) {
          if (this.companyOverview.hsecases[i].length !== 0) {
            result += 1;
          }
        }
      }

      return result;
    },
    numberOfSanctions() {
      let result = 0;

      if (this.companyOverview && this.companyOverview.sanctions) {
        for (let i = 0; i < this.companyOverview.sanctions.length; i += 1) {
          if (this.companyOverview.sanctions[i].length !== 0) {
            result += 1;
          }
        }
      }

      return result;
    },
  },
  methods: {
    /**
     * Convert camelCase to words.
     * Courtesy of: https://stackoverflow.com/questions/21147832/convert-camel-case-to-human-readable-string
     *
     * @param str
     * @returns {*}
     */
    camelCaseToWords(str) {
      return str
        .match(/^[a-z]+|[A-Z][a-z]*/g)
        .map((x) => x[0].toUpperCase() + x.substr(1).toLowerCase())
        .join(' ');
    },

    /**
     * Present the data or the errorMsg (if given)
     *
     * @param data
     * @param errorMsg
     * @returns {*}
     */
    dataOrError(data, errorMsg) {
      if (data == null || data.length === 0) {
        if (typeof errorMsg === 'undefined') {
          return '-';
        }
        return errorMsg;
      }
      return data;
    },

    /**
     * Format the age as per value and period
     *
     * @param value
     * @param period
     * @returns {string}
     */
    formatAge(value, period) {
      if (typeof period === 'undefined') {
        return `${Math.floor(value)} `;
      }
      return `${Math.floor(value)} ${period}`;
    },

    /**
     * Reformat YYYY-MM-DD dates into DD/MM/YYYY, unless `long` then the format is dddd do MMMM YYYY
     *
     * @param dateString
     * @returns {string}
     */
    formatDate(dateString) {
      // eslint-disable-next-line no-console
      // console.error('Please call DateTools::formatDate() in the future. GeneralTools::formatDate '
      //   + 'function is being deprecated.');
      if (typeof dateString === 'undefined' || !dateString) {
        return '';
      }
      return moment(dateString, 'YYYY-MM-DD').format('DD/MM/YYYY');
    },

    /**
     * Reformat YYYY-MM-DD HH:mm:ss datetimes into DD/MM/YYYY HH:mm:ss
     *
     * @param dateTimeString
     * @returns {string}
     */
    formatDateTime(dateTimeString) {
      if (typeof dateTimeString === 'undefined' || !dateTimeString) {
        return '';
      }
      return moment(dateTimeString, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss');
    },
  },
};
